// removed by extract-text-webpack-plugin
module.exports = {"label":"Label__label___2vykN","isToggleLeft":"Label__isToggleLeft___1HFBk","isToggleRight":"Label__isToggleRight___3EJez"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Label/Label.scss
// module id = 595
// module chunks = 0